import { useIsCommercialSuretyEnabled } from "@portal/hooks/useIsCommercialSuretyEnabled";
import { useFormContext, useWatch } from "react-hook-form";
import type { AccountFormValues } from "../../schema";
import { shouldShowContractHistoryQuestions } from "./contractHistoryQuestions";

export const useShowContractHistoryQuestions = () => {
	const isCommercialSuretyEnabled = useIsCommercialSuretyEnabled();
	const { control } = useFormContext<AccountFormValues>();
	const requiresPaymentAndPerformanceBonds = useWatch({
		control,
		name: "requiresPaymentAndPerformanceBonds",
	});

	return shouldShowContractHistoryQuestions(
		isCommercialSuretyEnabled,
		requiresPaymentAndPerformanceBonds,
	);
};
